import { render, staticRenderFns } from "./FacturaGas.vue?vue&type=template&id=50c80067&"
import script from "./FacturaGas.vue?vue&type=script&lang=js&"
export * from "./FacturaGas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports